import { MapPin } from "lucide-react";

const serviceAreas = [
  { region: "Southfield & Neighbors", cities: ["Southfield", "Lathrup Village", "Oak Park", "Berkley", "Royal Oak", "Ferndale", "Beverly Hills"] },
  { region: "Detroit Metro", cities: ["Detroit", "Dearborn", "Dearborn Heights", "Redford", "Inkster", "Romulus", "Taylor", "Westland"] },
  { region: "Oakland County", cities: ["Farmington Hills", "Troy", "Pontiac", "Bloomfield Hills", "West Bloomfield", "Novi", "Rochester Hills", "Waterford", "Auburn Hills", "Clarkston"] },
  { region: "Greater Michigan", cities: ["Ann Arbor", "Ypsilanti", "Lansing", "Flint", "Saginaw", "Grand Rapids", "Kalamazoo", "Windsor (Ontario)"] },
];

const ServiceAreasSection = () => {
  return (
    <section className="py-16 md:py-20 border-t border-brand-border bg-brand-surface" data-testid="service-areas-section">
      <div className="max-w-5xl mx-auto px-6 md:px-12">
        <div className="text-center mb-10">
          <p className="text-xs uppercase tracking-[0.2em] font-sans text-brand-gold mb-3">Serving All of Michigan</p>
          <h2 className="font-serif text-2xl md:text-3xl text-brand-text">Our Service Areas</h2>
          <p className="font-sans text-sm text-brand-text-muted mt-2 max-w-lg mx-auto">
            Clients drive from across Michigan for our premium braiding services. We proudly serve the following areas.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {serviceAreas.map((area) => (
            <div key={area.region} className="border border-brand-border p-5 bg-brand-bg">
              <h3 className="font-sans text-sm text-brand-gold font-semibold mb-3 flex items-center gap-2">
                <MapPin size={14} /> {area.region}
              </h3>
              <ul className="space-y-1.5">
                {area.cities.map((city) => (
                  <li key={city} className="font-sans text-xs text-brand-text-muted">{city}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <p className="text-center font-sans text-xs text-brand-text-muted mt-8">
          Don't see your city? We welcome clients from anywhere! Call <a href="tel:+13134847307" className="text-brand-gold hover:underline">(313) 484-7307</a> to book.
        </p>
      </div>
    </section>
  );
};

export default ServiceAreasSection;
